import { createFileRoute, Outlet } from "@tanstack/react-router";

import { InShellNotFound } from "../../components/auth/InShellNotFound";
import { InsufficientRoleView } from "../../components/auth/InsufficientRoleView";
import { useViewerRoles } from "../../components/auth/ViewerRolesContext";

export const Route = createFileRoute("/_authed/admin")({
  component: AdminLayout,
  notFoundComponent: InShellNotFound,
});

function AdminLayout() {
  const { isNuAdmin } = useViewerRoles();

  if (!isNuAdmin) {
    return (
      <InsufficientRoleView description="This area is for Nubank admins only." />
    );
  }

  return <Outlet />;
}
